import React, { useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";

interface IAlterationsListAddElementProps {
  idAlterationForm: number;
  onCreate: (
    name: string,
    type: string,
    idAlterationForm?: number | undefined
  ) => void;
}

function AlterationsListAddElement({
  idAlterationForm,
  onCreate,
}: IAlterationsListAddElementProps) {
  // Local state for the editable name
  const [name, setName] = useState("");
  // manage validation error messages
  const [nameValidationError, setNameValidationError] = useState("");

  // Handle saving the updated name
  const handleBlurOrEnter = (e?: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e || e.key === "Enter") {
      if (!name || name.trim().length < 4) {
        setNameValidationError(
          "Name must be at least 4 characters long. Please try again."
        );
      } else {
        setNameValidationError("");
        onCreate(name, "alteration", idAlterationForm);
      }
    }
  };

  return (
    <div className="alteration-add">
      <div>
        <label>Add new alteration:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleBlurOrEnter}
        />
        <div>{nameValidationError}</div>
      </div>
      <Button
        label="Create"
        purpose={ButtonAction.CREATE}
        type={ButtonType.ICON}
        onClick={handleBlurOrEnter}
      />
    </div>
  );
}

export default AlterationsListAddElement;
